import { Button, Drawer, Checkbox } from "antd";
import close from "./../../../../assets/images/close.svg";
import { useRef } from "react";

const FilterDrawer = ({
  closeDrawer,
  handleApplyFilter,
  selectedFilters,
  setSelectedFilters,
  handleResetAll,
}: any) => {
  const filterOptions = [
    { key: "0", label: "Upcoming" },
    { key: "3", label: "Completed" },
    { key: "4", label: "Cancelled" },
  ];

  const checkboxRefs = useRef<{ [key: string]: any }>({});

  const handleFilterToggle = (filterKey: string) => {
    setSelectedFilters((prev: any) => {
      const newFilters = prev.includes(filterKey)
        ? prev.filter((item: any) => item !== filterKey)
        : [...prev, filterKey];

      return newFilters;
    });
  };

  const handleResetAllClick = () => {
    // Clear all filter selections
    setSelectedFilters([]);
    // Reset applied filters to show all appointments
    handleResetAll();
    // Close the drawer
    closeDrawer();
  };

  const handleApplyFilterClick = () => {
    handleApplyFilter(selectedFilters);
  };

  const handleCloseDrawer = () => {
    // Reset selected filters to applied filters when closing without applying
    setSelectedFilters([]);
    closeDrawer();
  };

  return (
    <Drawer
      placement="bottom"
      onClose={handleCloseDrawer}
      closeIcon={false}
      open={true}
      height="auto"
      className="rounded-t-2xl overflow-hidden max-w-[450px] mx-auto"
      push={false}
    >
      <div className="flex flex-col h-full">
        <div className="flex justify-between items-center mb-4">
          <div className="font-semibold text-lg">Filter by Status</div>
          <img
            src={close}
            alt="close"
            onClick={handleCloseDrawer}
            className="w-6 h-6 cursor-pointer"
          />
        </div>

        <div className="flex flex-col gap-3 mb-6">
          {filterOptions.map((option) => (
            <div
              key={option.key}
              className="flex items-center gap-3 cursor-pointer p-2 rounded-lg hover:bg-gray-50"
              onClick={() => handleFilterToggle(option.key)}
            >
              <Checkbox
                ref={(el) => (checkboxRefs.current[option.key] = el)}
                checked={selectedFilters.includes(option.key)}
                onClick={(e) => {
                  e.stopPropagation();
                  handleFilterToggle(option.key);
                }}
                className="cursor-pointer"
              />
              <span className="text-base text-gray-700 cursor-pointer flex-1">
                {option.label}
              </span>
            </div>
          ))}
        </div>

        <div className="flex flex-col gap-3">
          <Button
            className="w-full h-[50px] text-base font-medium bg-[#4B4AD5] text-white border-[#4B4AD5] rounded-xl hover:bg-[#4B4AD5] hover:border-[#4B4AD5]"
            onClick={handleApplyFilterClick}
            disabled={selectedFilters.length === 0}
          >
            Apply Filter
            {selectedFilters.length > 0 ? `(${selectedFilters.length})` : ""}
          </Button>

          <button
            className="text-gray-500 text-center text-sm underline hover:text-gray-700"
            onClick={handleResetAllClick}
          >
            Reset All
          </button>
        </div>
      </div>
    </Drawer>
  );
};

export default FilterDrawer;
